/* unplugin-vue-components disabled */import script from "./UploadContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadContainer.vue?vue&type=script&setup=true&lang=ts"

import "./UploadContainer.vue?vue&type=style&index=0&id=0629908c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0629908c"]])

export default __exports__